import { Link, useLocation } from "react-router-dom";

const LINKS = [
  { to: "/steward-and-stone", label: "Overview" },
  { to: "/steward-and-stone/healthcare-advisory", label: "Healthcare Advisory" },
  { to: "/steward-and-stone/operational-strategy", label: "Operational Strategy" },
  { to: "/steward-and-stone/assessment", label: "Request a Review" },
];

// Local subsection nav for Steward & Stone. Page-level brand identification is
// intentionally omitted — the persistent global JMH header sits above this.
export const StewardStoneNav = () => {
  const { pathname } = useLocation();
  return (
    <div className="pt-20 md:pt-24 px-6" data-testid="ss-local-nav">
      <div className="mx-auto border-b border-[rgba(180,139,63,0.16)] pb-4 jmh-content-shell">
        <nav className="flex items-center gap-x-6 gap-y-2 flex-wrap" aria-label="Steward & Stone sections">
          {LINKS.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              data-testid={`ss-nav-${l.label.toLowerCase().replace(/[^a-z]+/g, "-").replace(/^-|-$/g, "")}`}
              className={`font-display uppercase tracking-wide2 text-[10px] link-underline transition-colors ${pathname === l.to ? "text-[var(--gold-lite)]" : "text-[var(--bone)]/80 hover:text-[var(--gold-lite)]"}`}
            >
              {l.label}
            </Link>
          ))}
        </nav>
      </div>
    </div>
  );
};
